import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlNgCommonModule } from '@blcloud/bl-ng-common';
import { BlNgUiComponentModule, NumberPlateViewComponent } from '@blcloud/bl-ng-ui-component';
import { WebReserveResource, WebReserveLinkReqResource, WebReserveLinkCandidateResource } from '@blcloud/bl-ng-resource';
import { LoginResourceService } from '@blcloud/bl-ng-share-module';
import { CustomerVehicleSearchResourceService } from '@blcloud/bl-ng-share-module';
import { CustomerVehicleInfoBarModule } from '@blcloud/bl-ng-vehicle-customer-module';
import { WebReserveReceptionLinkComponent } from './web-reserve-reception-link.component';
import { WebReserveReceptionLinkService } from './web-reserve-reception-link.service';
import { AgGridModule } from 'ag-grid-angular';

/**
 * Web予約受付紐付モジュール
 */
@NgModule({
  imports: [
    CommonModule,
    BlNgCommonModule,
    BlNgUiComponentModule,
    CustomerVehicleInfoBarModule.forRoot(),
    AgGridModule.withComponents([
      NumberPlateViewComponent
    ]),
  ],
  declarations: [
    WebReserveReceptionLinkComponent
  ],
  entryComponents: [
    WebReserveReceptionLinkComponent
  ],
})
export class WebReserveReceptionLinkModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: WebReserveReceptionLinkModule,
      providers: [
        WebReserveResource,
        WebReserveLinkReqResource,
        WebReserveLinkCandidateResource,
        WebReserveReceptionLinkService,
        CustomerVehicleSearchResourceService,
        LoginResourceService,
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/web-reserve-reception-link/web-reserve-reception-link.module.ts